import { useState, useEffect, useCallback } from 'react';

export const useRealtimeData = (fetchFn, dataType) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    try {
      const result = await fetchFn();
      setData(result);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [fetchFn]);

  useEffect(() => { fetch(); }, [fetch]);

  return { data, loading, refresh: fetch };
};
